import gql from 'graphql-tag';

export const EditorRevertDialogContentQuery = gql`
	query EditorRevertDialogContentQuery($contentId: ID, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				type
				version {
					number
				}
				metadata {
					labels {
						id
						name
					}
				}
				links {
					webui
					context
				}
			}
		}
	}
`;
